import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Base64 } from 'js-base64';
import { MustMatch } from 'src/app/Components/new-password/must-match.validator';
import { AccessTokenService } from 'src/app/Services/access-token.service';
import { AlertService } from 'src/app/Services/alert.service';
import { DynamicDataService } from 'src/app/Services/dynamic-data.service';
import { UserDataProviderService } from 'src/app/Services/user-data-provider.service';
import { MaterialModule } from 'src/app/Shared/MaterialModule/material/material.module';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule, TranslateModule],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent implements OnInit {

  hide = true;
  userFormGroup!: FormGroup;
  submitted = false;
  fieldTextType = false;

  pageDynamicData: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private alertServie: AlertService,
    private _userDataProviderService: UserDataProviderService,
    private accessTokenService: AccessTokenService,
    public dynamicDataService: DynamicDataService,
    private translate: TranslateService,
  ) {
    this.userFormGroup = this.formBuilder.group({
      userOldPassword: ['', [Validators.required]],
      userNewPassword: ['', [Validators.required, Validators.pattern('(?=\\D*\\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z]).{8,25}')]],
      userConfirmPassword: ['', [Validators.required]]
    }, {
      validator: MustMatch('userNewPassword', 'userConfirmPassword')
    });
  }

  ngOnInit(): void {
    if (this.dynamicDataService.getDataFromLocal('ChangePassword') != null) {
      this.pageDynamicData = this.dynamicDataService.getDataFromLocal('ChangePassword');
    } else {
      this.getPageData();
    }
  }

  getPageData() {
    const requestBody = {
      UserID: this.accessTokenService.getUserId(),
      pageName: 'ChangePassword'
    };
    this.dynamicDataService.getPageData(requestBody).subscribe((res: any) => {
      if (res['status'] == 'success') {
        this.pageDynamicData = res['data'];
        this.dynamicDataService.setDataToLocal('ChangePassword', this.pageDynamicData);
      } else {
        this.alertServie.openAlert(res['message'], 'error');
      }
    });
  }

  changePassword() {
    this.submitted = true;

    if (this.userFormGroup.invalid) return;

    // console.log(this.userFormGroup.value);
    const requestBody = {
      Organization_Id:this.accessTokenService.getOrganizationId(),
      UserEmail: this.accessTokenService.getUserEmail(),
      ActionBy: this.accessTokenService.getUserId(),
      UserId: this.accessTokenService.getUserId(),
      newpwd: Base64.encode(this.userFormGroup.controls['userConfirmPassword'].value),
      oldpwd: Base64.encode(this.userFormGroup.controls['userOldPassword'].value)
    }
    this._userDataProviderService.changePassword(requestBody).subscribe((response: any) => {
      if (response.status == 'success') {
        this.alertServie.openAlert(this.translate.instant('Password updated successfully !'), 'success');
        this.dialogRef.close({ refreshPage: true });
      } else {
        this.alertServie.openAlert(this.translate.instant('Something went wrong, try again later !'), 'error');
      }
    });
  }
  get userFormControls() { return this.userFormGroup.controls; }

  togglePassword() {
    this.fieldTextType = !this.fieldTextType;
  }

}
